import React from 'react';

const Courses = () => {
  const courses = [
    {
      title: 'Hand Embroidery',
      duration: '1 Month',
      level: 'Beginner',
      price: '₹1,500',
      features: [
        'Basic embroidery stitches',
        'Thread work techniques',
        'Design patterns and motifs',
        'Hand-eye coordination training',
        'Practical project completion',
        'Certificate upon completion'
      ]
    },
    {
      title: 'Stitching Course',
      duration: '3 Months',
      level: 'Intermediate',
      price: '₹6,000',
      features: [
        'Sewing machine operation',
        'Basic garment construction',
        'Pattern making fundamentals',
        'Measurement and fitting',
        'Salwar suit stitching',
        'Blouse and kurti making',
        'Professional certification'
      ],
      popular: true
    },
    {
      title: 'Short Term Crash Course',
      duration: '2 Months',
      level: 'Fast Track',
      price: '₹4,000',
      features: [
        'Quick learning program',
        'Essential stitching skills',
        'Basic alteration techniques',
        'Simple garment making',
        'Time-efficient training',
        'Practical hands-on sessions',
        'Course completion certificate'
      ]
    },
    {
      title: 'Full Stitching Course',
      duration: '6 Months+',
      level: 'Professional',
      price: '₹14,000',
      features: [
        'Complete tailoring mastery',
        'Advanced pattern making',
        'All types of garment construction',
        'Bridal wear and heavy embroidery',
        'Fashion design principles',
        'Business setup guidance',
        'Industry placement assistance',
        'Lifetime alumni support'
      ]
    }
  ];

  const handleEnroll = (course) => {
    const message = `Hi, I want to enroll in *${course.title}* course.\n\nDuration: ${course.duration}\nFee: ${course.price}\n\nPlease share enrollment details.\n\nEmail: krystalapparelstore@gmail.com`;
    const whatsappUrl = `https://wa.me/916392782674?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="pt-20" data-testid="courses-page">
      {/* Hero Section */}
      <section className="relative h-[50vh] bg-cover bg-center" 
        style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1756483509162-b92ea967a884?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920)' }}
      >
        <div className="absolute inset-0 bg-[#2B2B2B] bg-opacity-70"></div>
        <div className="relative h-full flex items-center justify-center text-center px-4">
          <div>
            <h1 className="font-playfair text-5xl sm:text-6xl lg:text-7xl text-[#F8F6F0] mb-4">
              Tailoring Courses
            </h1>
            <p className="font-montserrat text-lg text-[#D4AF37] tracking-widest">
              Master the Art of Fashion Design
            </p>
          </div>
        </div>
      </section>

      {/* Courses Grid */}
      <section className="py-20 px-4 bg-[#F8F6F0]" data-testid="courses-grid">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-playfair text-4xl sm:text-5xl text-[#2B2B2B] mb-6">
              Choose Your Path
            </h2>
            <p className="font-montserrat text-base text-[#2B2B2B] max-w-2xl mx-auto">
              From beginner basics to professional mastery, we offer comprehensive courses 
              designed to nurture your creativity and technical skills.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {courses.map((course, index) => (
              <div 
                key={index}
                className={`bg-white rounded-lg overflow-hidden hover:shadow-2xl transition-all duration-300 ${
                  course.popular ? 'ring-4 ring-[#D4AF37] transform scale-105' : 'shadow-lg'
                }`}
                data-testid={`course-card-${index}`}
              >
                {course.popular && (
                  <div className="bg-[#D4AF37] text-[#2B2B2B] text-center py-2 font-montserrat text-sm font-bold tracking-widest">
                    MOST POPULAR
                  </div>
                )}
                
                <div className="p-8">
                  <div className="text-center mb-6">
                    <h3 className="font-playfair text-3xl text-[#2B2B2B] mb-2">
                      {course.title}
                    </h3>
                    <span className="inline-block bg-[#F8F6F0] text-[#D4AF37] font-montserrat text-xs px-3 py-1 rounded-full">
                      {course.level}
                    </span>
                  </div>

                  <div className="text-center mb-6">
                    <div className="font-playfair text-5xl text-[#D4AF37] mb-2">
                      {course.price}
                    </div>
                    <div className="font-montserrat text-sm text-[#2B2B2B]">
                      {course.duration} Duration
                    </div>
                  </div>

                  <ul className="space-y-3 mb-8">
                    {course.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start font-montserrat text-sm text-[#2B2B2B]">
                        <svg className="w-5 h-5 text-[#D4AF37] mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  <button 
                    onClick={() => handleEnroll(course)}
                    className={`w-full py-3 font-montserrat text-sm tracking-widest transition-colors duration-300 ${
                      course.popular
                        ? 'bg-[#D4AF37] text-[#2B2B2B] hover:bg-[#2B2B2B] hover:text-[#D4AF37]'
                        : 'bg-[#2B2B2B] text-[#F8F6F0] hover:bg-[#D4AF37] hover:text-[#2B2B2B]'
                    }`}
                    data-testid={`enroll-button-${index}`}
                  >
                    ENROLL NOW
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-playfair text-4xl sm:text-5xl text-[#2B2B2B] text-center mb-16">
            Why Learn With Us?
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-[#2B2B2B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </div>
              <h3 className="font-playfair text-xl text-[#2B2B2B] mb-2">Expert Instructors</h3>
              <p className="font-montserrat text-sm text-[#2B2B2B]">
                Learn from industry professionals with years of experience
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-[#2B2B2B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <h3 className="font-playfair text-xl text-[#2B2B2B] mb-2">Modern Facilities</h3>
              <p className="font-montserrat text-sm text-[#2B2B2B]">
                State-of-the-art equipment and comfortable learning environment
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-[#2B2B2B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="font-playfair text-xl text-[#2B2B2B] mb-2">Certification</h3>
              <p className="font-montserrat text-sm text-[#2B2B2B]">
                Industry-recognized certificates upon course completion
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-[#2B2B2B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="font-playfair text-xl text-[#2B2B2B] mb-2">Career Support</h3>
              <p className="font-montserrat text-sm text-[#2B2B2B]">
                Placement assistance and career guidance for all students
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Courses;
